import {
  SET_ALL_AREA,
  SET_MOUNT_PATH,
  SET_SOFTWARE,
  SET_DIALOG,
  SET_UP_DIALOG,
  SET_CITYS,
  SET_PROVINCE,
  SET_PLATFORMS,
  SET_ALL_PLATFORMS,
  SET_USERINFO,
  SET_PERMISSION,
  SET_CONSTRAINT,
  SET_DIALOG_BUSINESS,
  SET_CGLIST,
  UPDATE_DIALOG,
  SET_ALL_TASK_CONSTRAINT,
  SET_PLATFORM,
  SET_PLUGIN,
  SET_FULL_SPEED_DATA,
} from './mutation-types'
import { SET_AUTH_USER_STATUS } from '@/store/modules/auth/mutation-types'
import store from '@/store'
import api from '@/api'
import _ from 'lodash'
import {initAdminTree, getTreeIndex} from '@/utils/permission'
import userUpdate from './userUpdate'
import columnFilter from './columnFilter'
import dashbroad from './dashbroad'
import cgTree from './cgTree'
import { OverseasMap } from '@/constants/user'
import { checkMobileAgent } from '@/utils/user-agent'

const getStateInstance = () => ({
  key: 0,
  type: 'inform',
  visible: false,
  customClass: 'app-infom',
  title: '',
  description: '',
  slot: '',
  isHasInput: false,
  component: '',
  titleComponent: '',
  componentData: '',
  top: '15vh',
  width: checkMobileAgent() ? 'max-content' : '50%',
  closeOnClickModal: true,
  confirmed: '',
  query: '',
})

const state = {
  area: [],
  mountPath: [],
  software: [],
  dialog: getStateInstance(),
  upDialog: getStateInstance(),
  province: [],
  allPlatforms: [],
  platforms: [],
  platform: parseInt(sessionStorage.getItem('platform')),
  cgList: [],
  userInfo: '',
  permission: '',
  constraint: '',
  taskConstraints: {
    storage: [],
    task: [],
  },
  osList: [
    {id: 1, label: 'linux'},
    {id: 2, label: 'windows'},
  ],
  plugin: [],
  fullSpeedData: null,
  dependency: [],
}
const mutations = {
  [SET_FULL_SPEED_DATA] (state, payload) {
    state.fullSpeedData = payload
  },
  [SET_ALL_AREA] (state, payload) {
    state.area = payload
  },
  [SET_MOUNT_PATH] (state, payload) {
    state.mountPath = payload
  },
  [SET_SOFTWARE] (state, payload) {
    state.software = payload
  },
  [UPDATE_DIALOG] (state, payload) {
    state.dialog.componentData = {
      ...state.dialog.componentData,
      ...payload,
    }
  },
  [SET_DIALOG] (state, payload) {
    state.dialog = {
      ...state.dialog,
      ...payload,
    }
  },
  // 业务员按区域分配
  [SET_DIALOG_BUSINESS] (state, payload) {
    state.dialog.componentData = {
      ...state.dialog.componentData,
      ...payload,
    }
  },
  [SET_UP_DIALOG] (state, payload) {
    state.upDialog = {
      ...state.upDialog,
      ...payload,
    }
  },
  [SET_PROVINCE] (state, payload) {
    state.province = payload
  },
  [SET_CITYS] (state, {current, list}) {
    current.children = list
  },
  [SET_PLATFORMS] (state, payload) {
    state.platforms = payload
  },
  [SET_ALL_PLATFORMS] (state, payload) {
    state.allPlatforms = payload
  },
  [SET_USERINFO] (state, payload) {
    state.userInfo = payload
  },
  [SET_PERMISSION] (state, payload) {
    state.permission = payload
  },
  [SET_CONSTRAINT] (state, payload) {
    state.constraint = payload
  },
  [SET_CGLIST] (state, payload) {
    state.cgList = payload
  },
  [SET_ALL_TASK_CONSTRAINT] (state, payload) {
    state.taskConstraints = payload
  },
  [SET_PLATFORM] (state, payload) {
    state.platform = payload
  },
  [SET_PLUGIN](state, payload) {
    state.plugin = payload
  },
}

const actions = {
  async setAllArea ({commit}) {
    if (state.area.length > 0) return false
    const {data} = await api.homeApi.getALlArea()
    // const _data = data.map(v => {
    //   v.areaProperties = v.areaProperties.toLocaleLowerCase()
    //   return v
    // })
    commit('SET_ALL_AREA', [...data].map(item => {
      return Object.assign(item, { areaProperties: item.areaProperties === 'HW' ? OverseasMap.get(item.id) : item.areaProperties })
    }))
  },
  async setMountPath ({commit}, payload) {
    const {data} = await api.homeApi.getMountPath(payload)
    commit('SET_MOUNT_PATH', data)
  },
  async setSoftware ({commit}) {
    const {data} = await api.homeApi.getSoftware()
    commit('SET_SOFTWARE', data)
  },
  async setPlugin ({commit}) {
    const {data} = await api.homeApi.getPlugin({})
    let pluginList = []
    Object.keys(data).forEach(function(key) {
      pluginList.push({pluginName: key})
    })
    commit('SET_PLUGIN', pluginList)
  },
  async getSoftwareVersion ({commit}, payload) {
    const {data} = await api.homeApi.getSoftwareVersion(payload)
    return data
  },
  async getPluginVersion ({commit}, payload) {
    const {data} = await api.homeApi.getPlugin(payload)
    let pluginListVersion = []
    Object.keys(data).forEach(function(key) {
      data[key].map(item => {
        pluginListVersion.push({pluginVersion: item.pluginVersion, pluginId: item.id})
      })
    })
    return pluginListVersion
  },
  changeGlobalDialog ({commit}, payload) {
    commit('SET_DIALOG', payload)
  },
  updateGlobalDialog ({commit}, payload) {
    commit('UPDATE_DIALOG', payload)
  },
  async getUserInfo ({commit, state}, refresh) {
    if (!refresh && state.userInfo) {
      return false
    }
    try {
      const {data} = await api.homeApi.getUserInfo()
      commit('SET_USERINFO', data)
      commit(`auth/${SET_AUTH_USER_STATUS}`, true, {root: true})
    } catch (error) {
      commit(`auth/${SET_AUTH_USER_STATUS}`, false, {root: true})
      throw error
    }
  },
  async getAllPermission ({commit}, payload) {
    if (state.permission) return false
    const {data} = await api.homeApi.getAllPermission()
    commit('SET_PERMISSION', data)
  },
  showGlobalDialog ({state, commit}, payload) {
    commit('SET_DIALOG', getStateInstance())
    payload = {
      ...payload,
      visible: true,
      confirmed: '',
    }
    commit('SET_DIALOG', payload)
    return new Promise((resolve, reject) => {
      const unwatch = store.watch(state => state.home.dialog.confirmed, () => {
        unwatch()
        resolve(state.dialog.confirmed)
      })
    })
  },
  changeGlobalUpDialog ({commit}, payload) {
    commit('SET_UP_DIALOG', payload)
  },
  showGlobalUpDialog ({state, commit}, payload) {
    commit('SET_UP_DIALOG', getStateInstance())
    payload = {
      ...payload,
      visible: true,
      confirmed: '',
    }
    commit('SET_UP_DIALOG', payload)
    return new Promise((resolve, reject) => {
      const unwatch = store.watch(state => state.home.upDialog.confirmed, () => {
        unwatch()
        resolve(state.upDialog.confirmed)
      })
    })
  },
  async getProvinceList ({commit, state}) {
    if (state.province.length > 0) return false
    const {data} = await api.homeApi.getProvinceList()
    const list = data.map(v => {
      return {
        label: v.province,
        value: v.province,
        id: v.code,
        children: [],
      }
    })
    commit('SET_PROVINCE', list)
  },
  async getCityList ({commit, state}, payload) {
    const current = state.province.find(item => item.label === payload)
    if (current.children.length > 0) return false
    const {data} = await api.homeApi.getCityList({provinceCode: current.id})
    const list = data.map(v => {
      return {
        label: v.city,
        value: v.city,
        id: v.code,
      }
    })
    commit('SET_CITYS', {current, list})
  },
  // 获取节点机状态详情(可共用)
  async getNodeStatusDetail ({state}, payload) {
    const data = await api.homeApi.getNodeStatusDetail(payload)
    return data
  },
  // 获取GPU使用率数据
  async getNodeGpuDetail ({state}, payload) {
    const data = await api.homeApi.getNodeGpuDetail(payload)
    return data
  },
  // 获取所有约束
  async getConstraintExceptStoarge ({commit}, payload) {
    const {data} = await api.homeApi.getConstraintExceptStoarge(payload)
    commit(SET_CONSTRAINT, data)
  },
  // 任务页面获取所有约束
  async getAllConstraints ({commit}) {
    const {data} = await api.homeApi.getAllConstraints({})
    commit(SET_ALL_TASK_CONSTRAINT, data)
  },
  // 获取所有平台号
  async getAllPlatforms ({commit, state}, payload = {}) {
    const options = payload || {}
    if (state.platforms.length > 0 && !options.force) return false
    const {data} = await api.homeApi.getAllPlatforms()
    const _data = data.map(v => ({
      ...v,
      name: v.name.replace(/query_platform_/g, ''),
    }))
    commit(SET_PLATFORMS, _data)
  },
  async getPlatformStatus({ commit }, payload) {
    const { data } = await api.homeApi.getPlatformStatus()
    const _data = data.map(v => ({
      ...v,
      name: v.name.replace(/query_platform_/g, ''),
    }))
    commit(SET_ALL_PLATFORMS, _data)
  },
  // 按区域分配业务员
  async getBusinessByZone ({commit}, payload) {
    // 11 国内 12 国外
    const {data} = await api.userApi.queryAdminByOrganizationType({organizationType: payload})
    commit(SET_DIALOG_BUSINESS, {list: data, organizationType: payload})
  },
  // 获取所有软件
  async getCgInfoMap ({state, commit}, payload) {
    if (state.cgList.length > 0) return false
    const {data} = await api.homeApi.getCgInfoMap(payload)
    commit(SET_CGLIST, data)
  },
  // 获取jira的入口
  async getJiraLoginUrl ({state, commit}, payload) {
    const data = await api.homeApi.getJiraLoginUrl(payload)
    return data
  },
  updatePlatform ({commit}, payload) {
    commit(SET_PLATFORM, payload)
    // 导航栏打开新标签/新窗口 能保存之前的平台号
    sessionStorage.setItem('platform', +payload)
    localStorage.setItem('commonPlatform', +payload)
  },
  async queryTemplateFieldByCgId({commit}, payload) {
    const {data} = await api.homeApi.queryTemplateFieldByCgId(payload)
    return data
  },
}

const getters = {
  // 0/GPU,1/CPU,2/效果图cpu,3/青云平台,4/GPU青云平台
  currentPlatformItem(state) {
    return state.platforms.find(i => i.platform === state.platform)
  },
  isGpuPlatform(state, getters) {
    if (getters.currentPlatformItem) {
      return [0, 4].includes(getters.currentPlatformItem.type)
    }
    return false
  },
  isCpuPlatform(state, getters) {
    if (getters.currentPlatformItem) {
      return [1, 2, 3].includes(getters.currentPlatformItem.type)
    }
    return false
  },
  animationType (state) {
    return state.area.filter(v => v.businessType === 1 || v.businessType === 2)
  },
  effectType (state) {
    return state.area.filter(v => v.businessType === 0 || v.businessType === 2)
  },
  effectTypeNew (state) {
    return state.area.filter(v => v.businessType === 0 || v.businessType === 2 || v.businessType === 1)
  },
  daYanType (state) {
    return state.area.filter(v => v.businessType === 1 || v.businessType === 2)
  },
  foreignType (state) {
    return state.area.filter(v => v.zone === 2 || v.businessType === 2)
  },
  animationRegisterType (state, getters) {
    return getters.animationType.filter(v => !(v.areaProperties === 'GH' || v.areaProperties === 'ZOMBIE'))
  },
  effectRegisterType (state, getters) {
    return getters.effectType.filter(v => !(v.areaProperties === 'GH' || v.areaProperties === 'ZOMBIE'))
  },
  daYanRegisterType (state, getters) {
    return getters.daYanType.filter(v => !(v.areaProperties === 'GH' || v.areaProperties === 'ZOMBIE'))
  },
  // 所有权限控制的列表
  permissionList (state) {
    if (!state.permission) return []
    if (state.permission && !state.userInfo.authorities) {
      return state.permission.map(v => ({
        status: false,
        parameters: null,
        children: [],
      }))
    }
    let allPermission = _.cloneDeep(state.permission)
    let userPermission = _.cloneDeep(state.userInfo.authorities)
    initAdminTree(allPermission, 'init')
    initAdminTree(userPermission, 'assign')
    diffTree(allPermission, userPermission)
    let list = {}
    function flatArray (arr) {
      arr.forEach(v => {
        const {name, parameters, status, children} = v
        list[name] = {
          status,
          parameters,
          children,
        }
        if (children) {
          flatArray(children)
        }
      })
    }
    flatArray(allPermission)
    userPermission.forEach(v => {
      if (!v.children) list[v.name].status = false
      else {
        v.children.forEach((vc) => {
          if (!vc.children) {
            list[vc.name].children = undefined
          }
        })
      }
    })
    return list
  },
  // 当前用户区域
  adminAreaList (state, getters) {
    if (!getters.permissionList) return []
    if (!getters.permissionList['query:selected:area:customer:task'] && !getters.permissionList['query:selected:area:customer:task:dyy']) return []
    const mapString = getters.permissionList['query:selected:area:customer:task'].parameters
    const dayanMapString = getters.permissionList['query:selected:area:customer:task:dyy'].parameters
    if (!mapString && !dayanMapString) return []
    const map = mapString.split(',').map(v => state.area.find(k => k.id === parseInt(v))).filter(Boolean)
    const dayanMap = dayanMapString.split(',').map(v => state.area.find(k => k.id === parseInt(v))).filter(Boolean)
    return Array.from(new Set([...map, ...dayanMap]))
  },
  platformStatusList (state) {
    let temp = []
    if (state.platforms) {
      state.platforms.forEach(v => {
        temp.push(v.platform)
      })
    }
    return temp
  },
  channel (state) {
    return state.userInfo.channel
  },
  platformList (state) {
    return state.platforms.map(item => item.platform)
  },
  // 公有云平台，测试环境用效果图区代替
  isPublicCloudPlatform (state) {
    const publicCloudPlatformList = window.location.href.includes('admin.renderbus.com') ? [38, 65, 66, 67, 68, 72, 73, 74, 76] : [4]
    return publicCloudPlatformList.includes(state.platform)
  },
  isAliPlatform (state) {
    const aliPlatformList = window.location.href.includes('admin.renderbus.com') ? [71] : [4]
    return aliPlatformList.includes(state.platform)
  },
  // 有小镜像平台
  isHasMinImagePlatform (state) {
    const minImagePlatformList = window.location.href.includes('admin.renderbus.com') ? [38, 74] : [4]
    return minImagePlatformList.includes(state.platform)
  },
  //  72 爱捷云 73 GPU4区 74 线上测试平台 75 爱捷云(青云2区)
  isTencentPlatform (state) {
    const arr = window.location.href.includes('admin.renderbus.com') ? [72, 73, 74, 76] : [4]
    return arr.includes(state.platform)
  },
  isHuoshanPlatform (state) {
    return [68].includes(state.platform)
  },
  isPublicPlatform (state) {
    const publicPlatformList = window.location.href.includes('admin.renderbus.com') ? [8, 38, 66] : [4]
    return publicPlatformList.includes(state.platform)
  },
  isShowStorageIdPlatform(state) {
    const list = window.location.href.includes('admin.renderbus.com') ? [38] : [62]
    return list.includes(state.platform)
  },
  userInfo(state) {
    return state.userInfo
  },
}

function diffTree (base, assign) {
  assign.forEach(v => {
    try {
      let node = getTreeIndex(base, v.treeIndex)
      node.status = true
      node.parameters = v.parameters
      if (v.children) {
        diffTree(base, v.children)
      }
    } catch (error) {
      console.log(error)
      window.vm.$message.warning('权限有变更，如存在问题，请重新登录')
    }
  })
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    userUpdate,
    columnFilter,
    dashbroad,
    cgTree,
  },
}
